<template>
    <div class="modal fade" id="modalEditPriorityTag" role="dialog">
      <div
        class="modal-dialog modal-dialog-centered modal-scroll"
        style="max-width: 40%"
      >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title black-text" style="font-weight: bold">
                Pengaturan Staging Order
              </h4>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="resetPriorityValue()"
            >
              &times;
            </button>
          </div>
          <div class="modal-body" style="font-size: 0.875rem">
            <div class="container position-relative">
                <div class="row">
                    <div class="col-sm-5 pt-1">
                        Priority Status
                    </div>
                    <div class="col-sm-7">
                        <div class="row">
                            <div v-for="option in statusOptionList" :key="option.label">
                                <div class="col-sm" v-if="option.label == 'Warm'">
                                    <button :class="selectedOrderPriority.label == 'Warm' ? `btn btn-sm btn-warm-selected` : 'btn btn-sm btn-warm'" @click="hasEditPermission ? changeStatus(option) : null" style="font-weight : 500; font-size: 0.813rem;width: 100%;">
                                        <img v-if="selectedOrderPriority.label !== 'Warm'" src='~@/assets/icon/warm-yellow.png' width="16px" height="16px" style="margin-bottom : 2px;"/>
                                        <img v-else src='~@/assets/icon/warm-white.png' width="16px" height="16px" style="margin-bottom : 2px;"/>
                                        {{option.label}}
                                    </button>
                                </div>
                                <div class="col-sm" v-else-if="option.label == 'Hot'">
                                    <button :class="selectedOrderPriority.label == 'Hot' ? `btn btn-sm btn-hot-selected` : 'btn btn-sm btn-hot'" @click="hasEditPermission ? changeStatus(option) : null" style="font-weight : 500; font-size: 0.813rem; width: 100%;">
                                        <img v-if="selectedOrderPriority.label !== 'Hot'" src="~@/assets/icon/hot-red.png" width="16px" height="16px" style="margin-bottom : 2px;"/>
                                        <img v-else src="~@/assets/icon/hot-white.png" width="16px" height="16px" style="margin-bottom : 2px;"/>
                                        Hot
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-5"></div>
                    <div class="col-sm-7 mb-3">
                      <span style="color : red; font-size: 0.625rem" v-if="errorFields.find(item => item.field == 'selectedOrderPriority')">{{errorFields.find(item => item.field == 'selectedOrderPriority').message}}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-sm-5 pt-2">
                        <span>Expected Deposit Date</span>
                    </div>
                    <div class="col-sm-7">
                        <input-date
                          id="expected-deposit-date"
                          :disabled="!hasEditPermission"
                          :value="expectedDepositDate"
                          placeholder="dd/mm/yyyy"
                          @change="expectedDepositDate = $event"
                        />
                        <span style="color : red; font-size: 0.625rem" v-if="errorFields.find(item => item.field == 'expectedDepositDate')">{{errorFields.find(item => item.field == 'expectedDepositDate').message}}</span>
                    </div>
                </div>
                <div class="row row mb-3">
                    <div class="col-sm-5 pt-2">
                        Tanggal Pengiriman
                    </div>
                    <div class="col-sm-7">
                      <input-date
                          id="max-delivery-date"
                          :disabled="!hasEditPermission"
                          :value="maxDeliveryDate"
                          placeholder="dd/mm/yyyy"
                          @change="maxDeliveryDate = $event"
                        />
                        <span style="color : red; font-size: 0.625rem" v-if="errorFields.find(item => item.field == 'maxDeliveryDate')">{{errorFields.find(item => item.field == 'maxDeliveryDate').message}}</span>
                    </div>
                </div>
                <component-guard :requiredPermissions="['2.9']">
                  <div class="row mb-3">
                      <div class="col-sm-5 pt-2">
                          <span>PIC Staging</span>
                      </div>
                      <div class="col-sm-7">
                        <single-select-v-2
                          :options="picStagingOptions"
                          :value="stagingPic"
                          @change="stagingPic = $event"
                          placeholder="Pilih PIC Staging"
                          :disabled="!hasEditAssignmentPermission"
                        />
                          <span style="color : red; font-size: 0.625rem" v-if="errorFields.find(item => item.field == 'stagingPic')">{{errorFields.find(item => item.field == 'stagingPic').message}}</span>
                      </div>
                  </div>
                  <div class="row mb-3">
                      <div class="col-sm-5 pt-2">
                          <span>Tanggal Pengerjaan Staging</span>
                      </div>
                      <div class="col-sm-7">
                          <input-date
                              id="staging-execution-date"
                              :value="stagingExecutionDate"
                              placeholder="dd/mm/yyyy"
                              @change="stagingExecutionDate = $event"
                              :disabled="!hasEditAssignmentPermission"
                          />
                          <span style="color : red; font-size: 0.625rem" v-if="errorFields.find(item => item.field == 'stagingExecutionDate')">{{errorFields.find(item => item.field == 'stagingExecutionDate').message}}</span>
                      </div>
                  </div>
                </component-guard>
            </div>
          </div>
          <div class="modal-footer">
            
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="resetPriorityValue()">
              {{ hasEditPermission ? 'Batal' : 'Tutup' }}
            </button>
            <div v-if="hasEditPermission">
              <button type="button" class="btn btn-primary" @click="validateForm()" :disabled="!isFormChanged">
                Selesai
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Swal from "sweetalert2";
  import Multiselect from "vue-multiselect";
  import DatePicker from "vue2-datepicker";
  import { SingleSelectV2, InputDate } from "../../Input";
  import { ComponentGuard, permissionMixin } from "../../Permissions";

  export default {
    name: "ModalEditPriorityTag",
    components: {
      Multiselect,
      DatePicker,
      SingleSelectV2,
      ComponentGuard,
      InputDate
    },
    mixins: [permissionMixin],
    props: [
        'orderId',
        'statusOptionList',
        'getData',
        'orderPriority',
        'onChangeOrderPriority',
        'employeeList',
    ],
    data() {
      return {
        errorFields: [],
        orderPriorityDetails: '',
        expectedDepositDate : '',
        maxDeliveryDate : '',
        stagingExecutionDate : '',
        stagingPic:'',
        selectedOrderPriority : {
            colorHex : '',
            label :'',
            tagId : 0,
        },
        formValuesBeforeChange : {
            expectedDepositDate : '',
            maxDeliveryDate : '',
            stagingExecutionDate : '',
            stagingPic:'',
            selectedOrderPriority : {
                colorHex : '',
                label :'',
                tagId : 0,
            },
        }
      };
    },
    computed: {
      hasEditSchedulingPermission() {
        return this.hasPermission({ requiredPermissions: ["2.4"] });
      },
      hasEditAssignmentPermission() {
        return this.hasPermission({ requiredPermissions: ["2.10"] });
      },
      hasEditPermission() {
        return this.hasEditAssignmentPermission || this.hasEditSchedulingPermission;
      },
      picStagingOptions() {
        return this.employeeList.map(employee => ({
          label: employee.employeeName,
          value: employee.id
        }));
      },
      isFormChanged() {
        return (
          this.expectedDepositDate !== this.formValuesBeforeChange.expectedDepositDate ||
          this.maxDeliveryDate !== this.formValuesBeforeChange.maxDeliveryDate ||
          this.stagingExecutionDate !== this.formValuesBeforeChange.stagingExecutionDate ||
          this.stagingPic !== this.formValuesBeforeChange.stagingPic ||
          this.selectedOrderPriority.tagId !== this.formValuesBeforeChange.selectedOrderPriority.tagId
        );
      }
    },
    methods: {
      removeInputError(field) {
        this.errorFields = this.errorFields.filter(item => item.field !== field);
      },
      async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
        localStorage.removeItem('jwt')
        localStorage.removeItem('admin_name')
        localStorage.removeItem('roles')
        localStorage.removeItem('user_email')
        localStorage.removeItem('admin_id')
        localStorage.removeItem('changeCatalogPermission')
        this.$router.push('/')
      },
        getOrderPriorityDetails() {
            // let swalWithBootstrapButtons = Swal.mixin({
            //     customClass: {
            //     confirmButton: "btn btn-primary ml-2",
            //     cancelButton: "btn btn-danger",
            //     },
            //     buttonsStyling: false,
            // });

            this.$http
            .post(
                `${process.env.GET_ORDER_PRIORITY_DETAIL}/${this.orderId}`,{},
                {
                    timeout: 30 * 1000,
                    headers: { "Asani-Token": localStorage.getItem("jwt") },
                }
            )
            .then((res) => {
            if (res.data.status == 200) {
                this.orderPriorityDetails = res.data.content;
                this.maxDeliveryDate = res.data.content.maxDeliverSchedule ? this.formatDateData(res.data.content.maxDeliverSchedule) : res.data.content.maxDeliverSchedule
                this.expectedDepositDate = res.data.content.expectedDepositDate ? this.formatDateData(res.data.content.expectedDepositDate) : res.data.content.expectedDepositDate
                this.stagingExecutionDate = res.data.content.stagingExecutionDate ? this.formatDateData(res.data.content.stagingExecutionDate) : res.data.content.stagingExecutionDate
                this.stagingPic = res.data.content.stagingPic ? res.data.content.stagingPic : this.stagingPic
                this.selectedOrderPriority = res.data.content.priorityOrder.tag ? res.data.content.priorityOrder.tag[0] : this.selectedOrderPriority
                this.formValuesBeforeChange = {
                    expectedDepositDate : this.expectedDepositDate,
                    maxDeliveryDate : this.maxDeliveryDate,
                    stagingExecutionDate : this.stagingExecutionDate,
                    stagingPic : this.stagingPic,
                    selectedOrderPriority : this.selectedOrderPriority
                }
            } else {
                Swal.fire({
                    title: "Sorry",
                    text: res.data.message,
                    icon: "error",
                    customClass: {
                      confirmButton: "btn btn-primary ml-2",
                      cancelButton: "btn btn-danger",
                    },
                    buttonsStyling: false,
                })
            }

            })
            .catch((err) => {
                Swal.fire({
                    title: "Error",
                    text: error.response.data.message,
                    icon: "error",
                    customClass: {
                      confirmButton: "btn btn-primary ml-2",
                      cancelButton: "btn btn-danger",
                    },
                    buttonsStyling: false,
                }).then(result => {
                  if(error.response.data.status == 401) {
                    this.handleLogout()
                  }
                })
            });
        },
        formatDateData(input) {
            let arr = input.split('/')
            return `${arr[2]}-${arr[1]}-${arr[0]}`
        },
        changeStatus(priority) {
          this.selectedOrderPriority = priority
        },
        updateOrderPriority() {
          if (!this.hasEditPermission) return; // Prevent update if user doesn't have permission
            // let swalWithBootstrapButtons = Swal.mixin({
            //     customClass: {
            //       confirmButton: "btn btn-primary ml-2",
            //       cancelButton: "btn btn-danger",
            //     },
            //     buttonsStyling: false,
            // });

            const sentData = {
                orderId : this.orderId,
                tagPriorityId : this.selectedOrderPriority.tagId ? this.selectedOrderPriority.tagId : 0,
                expectedDepositDate :this.expectedDepositDate,
                maxDeliverSchedule : this.maxDeliveryDate,
            }

            if (this.hasEditAssignmentPermission) {
              sentData.stagingExecutionDate = this.stagingExecutionDate
              sentData.stagingPic = this.stagingPic
            }

            this.$http.post(process.env.UPDATE_ORDER_PRIORITY,
            sentData,
            {
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 200) {
                    this.onChangeOrderPriority(this.selectedOrderPriority)
                    Swal.fire({
                        title:
                            `<strong style='font-size : 24px; font-weight : 600;'>${response.data.message}</strong>`,
                        icon: "success",
                        width: "32rem",
                        html: `
                            <div class="mt-3" style="max-width : 100%; font-size : 16px;">
                            Data berhasil diubah.
                            </div>
                        `,
                        reverseButtons: true,
                        showCancelButton: false,
                        focusConfirm: false,
                        confirmButtonText: `
                            Ok
                        `,
                        customClass: {
                          confirmButton: "btn btn-primary ml-2",
                          cancelButton: "btn btn-danger",
                        },
                        buttonsStyling: false,
                    })
                    .then((result) => {
                        this.resetPriorityValue()
                    })                      
                } else {
                    Swal.fire({
                        icon : 'error',
                        title : 'Error',
                        text :response.data.message,
                        customClass: {
                          confirmButton: "btn btn-primary ml-2",
                          cancelButton: "btn btn-danger",
                        },
                        buttonsStyling: false,
                    });
                    this.resetPriorityValue()
                }
            }).catch(error => {
              let errorMessage = 'Terjadi Kesalahan';
              if (error.response && error.response.data && error.response.data.message) {
                  errorMessage = error.response.data.message;
              }
              Swal.fire({
                icon : 'error',
                title : 'Error',
                text : errorMessage,
                customClass: {
                  confirmButton: "btn btn-primary ml-2",
                  cancelButton: "btn btn-danger",
                },
                buttonsStyling: false,
              }).then(result => {
                if(error.response && error.response.data && error.response.data.status == 401) {
                  this.handleLogout()
                }
              });
            })
        },
        resetPriorityValue() {
            this.getOrderPriorityDetails()
            this.getData()
            this.errorFields = []
            this.closeModal()
            this.expectedDepositDate = ''
            this.maxDeliveryDate = ''
            this.stagingExecutionDate = ''
            this.stagingPic = ''
        },
      closeModal() {
        $(`#modalEditPriorityTag`).modal("hide");
      },
      validateForm() {
        const errorFields = [];

        if (this.hasEditAssignmentPermission) {
          if(!this.stagingExecutionDate) {
            errorFields.push({field : 'stagingExecutionDate', message : 'Staging Date tidak boleh kosong'})
          }

          if(!this.stagingPic) {
            errorFields.push({field : 'stagingPic', message : 'PIC Staging tidak boleh kosong'})
          }
        }

        if(!this.expectedDepositDate) {
            errorFields.push({field : 'expectedDepositDate', message : 'Expected Deposit Date tidak boleh kosong'})
        } else {
            let today = new Date()
            let deposit = new Date(this.expectedDepositDate)
            if(deposit.getDate() < today.getDate() && deposit.getMonth() < today.getMonth() &&  deposit.getFullYear() < today.getFullYear()) {
                errorFields.push({field : 'expectedDepositDate', message : 'Expected Deposit Date tidak boleh lebih kecil dari tanggal hari ini'}) 
            }
        }

        if(!this.maxDeliveryDate) {
            errorFields.push({field : 'maxDeliveryDate', message : 'Tanggal Pengiriman tidak boleh kosong'})
        } else {
            let today = new Date()
            let deliver = new Date(this.maxDeliveryDate)
            if(deliver.getDate() < today.getDate() && deliver.getMonth() < today.getMonth() &&  deliver.getFullYear() < today.getFullYear()) {
                errorFields.push({field : 'maxDeliveryDate', message : 'Tanggal Pengiriman tidak boleh lebih kecil dari tanggal hari ini'}) 
            }
        }

        if (!this.selectedOrderPriority || !this.selectedOrderPriority.tagId) {
            errorFields.push({field : 'selectedOrderPriority', message : 'Priority Status tidak boleh kosong'})
        }
  
        this.errorFields = errorFields;
        if(errorFields.length == 0) {
            this.updateOrderPriority()
        }
      },
    },
    watch: {
      stagingPic(newVal) {
        if (newVal) {
          this.removeInputError('stagingPic');
        }
      },
      expectedDepositDate(newVal) {
        this.removeInputError('expectedDepositDate');
      },
      maxDeliveryDate(newVal) {
        this.removeInputError('maxDeliveryDate');
      },
      stagingExecutionDate(newVal) {
        this.removeInputError('stagingExecutionDate');
      },
      selectedOrderPriority(newVal) {
        if (newVal && newVal.tagId) {
          this.removeInputError('selectedOrderPriority');
        }
      },
    },
    mounted() {
      this.$watch(
        (vm) => [vm.isFinishGetDetail, vm.isFinishGetForm],
        (newVal) => {
          if (newVal[0] && newVal[1]) {
            this.handleMapOrderTagData();
          }
        }
      );
    },
    created() {
        this.getOrderPriorityDetails()
    },
  };
  $(document).ready(function () {
    var self = this;
    $('[data-toggle="tooltip"]').tooltip();
  });
  </script>
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  input[type="date"]:disabled{
    background-color: #f5f5f5;
    color: #999999;
  }

  .btn-warm-selected {
    border-radius: 100px;
    border: 1px solid #FBC797;
    background: #F78F30;
    color: #FFFFFF;
  }

  .btn-warm {
    border-radius: 100px;
    border: 1px solid #FBC797;
    background: #FFFFFF;
    color: #F78F30;
  }

  .btn-hot-selected {
    border-radius: 100px;
    border: 1px solid #FF99A1;
    background: #FF3444;
    color: #FFFFFF;
  }

  .btn-hot{
    border-radius: 100px;
    border: 1px solid #FF99A1;
    background: #FFFFFF;
    color : #FF3444;
  }
  .e-multiselect.e-input-group .e-multi-select-wrapper {
    background-color: red;
  }
  
  /* Chrome, Safari, Edge, Opera */
  .input_number input::-webkit-outer-spin-button,
  .input_number input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  /* Firefox */
  .input_number input[type="number"] {
    -moz-appearance: textfield;
  }
  
  ::-webkit-datetime-edit-year-field:not([aria-valuenow]),
  ::-webkit-datetime-edit-month-field:not([aria-valuenow]),
  ::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
    color: transparent;
  }

  
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px) {
    .mobile-div {
      padding: 2px 0px;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Order/CustomComponent/ModalOrderPriorityTag.vue